import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import classNames from 'classnames';
import colors from '../../utils/colors';
import Icon, { COLORS, ICONS } from './icon';

export const Button = styled.button`
	display: flex;
	padding: 16px 24px;
	width: 100%;
	justify-content: center;
	align-items: center;
	gap: 8px;
	flex: 1 0 0;
	border-radius: 100px;
`;

export const ButtonLabel = styled.label`
	font-size: 13px;
	font-weight: 600;
	line-height: 16px;
	cursor: pointer;
`;

const OptionsContainer = styled.div`
	position: absolute;
	bottom: calc(100% + 4px);
	left: 0;
	right: 0;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	z-index: 97;
	visibility: hidden;
	opacity: 0;
	transition: opacity 250ms;

	&.open {
		visibility: visible;
		opacity: 1;
	}
`;

export const OptionButton = styled.button`
	display: flex;
	justify-content: flex-start;
	align-items: center;
	align-self: stretch;
	padding: 8px 16px;
`;

export const OptionIconContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 16px;
	height: 16px;
	margin-right: 8px;
`;

export const OptionLabel = styled.label`
	font-size: 12px;
	font-weight: 500;
	line-height: 16px;
	letter-spacing: 0.24px;
`;

interface DropdownButtonProps {
	label: string;
	containerClassName?: string;
	children: React.ReactNode;
}

export default function DropdownButton({
	label,
	containerClassName = '',
	children,
}: DropdownButtonProps) {
	const [optionsOpen, setOptionsOpen] = useState<boolean>(false);

	const handleClick = () => {
		setOptionsOpen(false);
		window.removeEventListener('click', handleClick);
	};

	const handleOpenOptions = () => {
		if (!optionsOpen) {
			setOptionsOpen(true);
			setTimeout(() => {
				window.addEventListener('click', handleClick);
			}, 100);
		}
	};

	useEffect(() => () => {
		window.removeEventListener('click', handleClick);
	}, []);

	return (
		<div style={{ position: 'relative', width: '100%' }}>
			<Button className={classNames(optionsOpen && 'open')} onClick={handleOpenOptions}>
				<ButtonLabel className="bl-font-l1">{label}</ButtonLabel>
				<Icon
					name={
						optionsOpen
							? ICONS.KEYBOARD_ARROW_DOWN
							: ICONS.KEYBOARD_ARROW_UP
					}
					color={COLORS.TEXT_GRAY_200}
					size={12}
				/>
			</Button>
			<OptionsContainer
				className={classNames(containerClassName, 'field-group select', optionsOpen ? 'open' : '')}
			>
				{children}
			</OptionsContainer>
		</div>
	);
}